<div class="tab-switch-container">
  @for (tab of tabs; track tab; let i = $index) {
    <div class="tab-item">
      <button
        [ngClass]="{ active: isActive(tab) }"
        class="x_btn x_flat"
        [disabled]="disabled || tab.disabled"
        (click)="onTabClick(tab)"
      >
        <span class="tab-btn-indicator"></span>
        <div class="tab-btn-text">
          {{ tab.name | translate }}
        </div>
      </button>
    </div>
  }
</div>
